import { ReactElement, useEffect, useMemo, useState } from 'react';
import Header from 'containers/Header';
import { RfUiBreadcrumbs, RfUiButton, RfUiModal, RfUiMultiselect, RfUiDatepicker, RfUiCheckbox } from 'renfe-components';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  getAllUsuarios,
  insertarUsuarioPerfil,
  eliminarUsuarioPerfil,
  habilitarUsuarioPerfil,
} from 'store/usuarios/actions';
import { makeSelectAllUsuarios, makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import { makeSelectUsername } from 'store/app/selectors';
import { getSociedadesRequest } from 'store/practicas/actions';
import { makeSelectSociedadesParse } from 'store/practicas/selectors';
import {useCan} from 'hooks/visibilidadComponentes';
import './styles.css';
// Cursos
import { makeSelectCursosPracticaParse2 } from 'store/practicas/selectors';

import {
  makeSelectCursos,
} from 'store/cursos/selectors';
// Formadores
import { getAllFormadores, insertarFormadoresCursos, eliminarFormadoresCursos } from 'store/cursos/actions';
import { makeSelectAllFormadores } from 'store/cursos/selectors';

import {
  getCursos,
} from 'store/cursos/actions';

  const filtroCurso = {
    elemInicio: 0,
    // elemFin: 10, // Algunas peticiones cambian el nombre del parámetro
    elemFinal: 2147483647,
    orden: '',
    ascDesc: '',
    fechaInicio: 0,
    fechaFin: 9999999999999,
    sociedades: '',
    estados: '',
    cursos: '',
    provincias: '',
  };


/* ============= Utils ============= */
const arrayToAPI = (arr: any[]) => (arr?.map((x: any) => x.value).join(',') || '');
type Option = { label: string; value: any };

const normalizeUsuariosToOptions = (raw: any): Option[] => {
  try {
    if (typeof raw === 'string') raw = JSON.parse(raw);
  } catch {
    return [];
  }

  if (!Array.isArray(raw)) return [];

  // IDs bloqueados: usuarios con AL MENOS un 311 ACTIVO = 'S'
  const blockedIds = new Set<string>();
  for (const u of raw) {
    if (String(u?.ID_PERFIL) === '311' && String(u?.ACTIVO) === 'S') {
      blockedIds.add(String(u?.ID_USUARIO));
    }
  }

  // Normalizar sin bloqueados y sin duplicados
  const seenIds = new Set<string>();
  const result: Option[] = [];


  for (const u of raw) {
    const id = u?.ID_USUARIO;
    const nombre = u?.NOMBRE_USUARIO;
    if (!id || !nombre) continue;

    const idStr = String(id);

    if (blockedIds.has(idStr)) continue;
    if (seenIds.has(idStr)) continue;

    seenIds.add(idStr);
    result.push({ label: `${idStr} - ${nombre}`, value: idStr });
  }

  return result;
};

const extractTimestampMsString = (e: any): string => {
  if (e?.detail === undefined || e?.detail === null) return '';
  return String(e.detail);
};

const parseArrayMaybeJson = (raw: any): any[] => {
    try {
      if (typeof raw === 'string') return JSON.parse(raw);
    } catch {
      return [];
    }
    return Array.isArray(raw) ? raw : [];
};

const getValuesFromUIJson = (uiJson: string): string[] => {
  try {
    return (JSON.parse(uiJson || '[]') as any[])
      .map((x) => x?.value)
      .filter(Boolean)
      .map((v: any) => String(v));
  } catch {
    return [];
  }
};


const normalizeUsuariosToOptions2 = (raw: any): Option[] => {
  try {
    if (typeof raw === 'string') raw = JSON.parse(raw);
  } catch {
    return [];
  }

  if (!Array.isArray(raw)) return [];

  // IDs permitidos: usuarios con AL MENOS un perfil 311 ACTIVO = 'S'
  const allowedIds = new Set<string>();
  for (const u of raw) {
    if (String(u?.ID_PERFIL) === '311' && String(u?.ACTIVO) === 'S') {
      allowedIds.add(String(u?.ID_USUARIO));
    }
  }

  // Normalizar sin duplicados
  const seenIds = new Set<string>();
  const result: Option[] = [];

  for (const u of raw) {
    const id = u?.ID_USUARIO;
    const nombre = u?.NOMBRE_USUARIO;
    if (!id || !nombre) continue;

    const idStr = String(id);

    if (!allowedIds.has(idStr)) continue;
    if (seenIds.has(idStr)) continue;

    seenIds.add(idStr);
    result.push({ label: `${idStr} - ${nombre}`, value: idStr });
  }

  return result;
};

// Normaliza sociedades a options (label: "ID - NOMBRE", value: objeto sociedad)
const normalizeSociedadesToOptions = (raw: any): Array<{ label: string; value: any }> => {
  try {
    if (typeof raw === 'string') raw = JSON.parse(raw);
  } catch {
    return [];
  }
  if (!Array.isArray(raw)) return [];

  const seen = new Set<string>();

  return raw
    .map((s: any) => {
      const id = s?.ID_SOCIEDAD ?? s?.id ?? s?.value?.ID_SOCIEDAD;
      const nombre = s?.NOMBRE_SOCIEDAD ?? s?.nombre ?? s?.value?.NOMBRE_SOCIEDAD;
      if (!id || !nombre) return null;

      const idStr = String(id);
      if (seen.has(idStr)) return null;
      seen.add(idStr);

      return {
        label: `${idStr} - ${String(nombre)}`,
        value: s, // guardamos el objeto sociedad entero
      };
    })
    .filter(Boolean) as Array<{ label: string; value: any }>;
};

/* ============= solo para Alta Nuevo por campos ============= */
type AltaFormForm = { nombre: string; identificador: string; sociedadId: string };
async function existeEnRDA(id: string) {
  await new Promise((r) => setTimeout(r, 120));
  return id.trim().length > 0;
}

const usuarioExiste = (usuariosAll: any, identificador: string): boolean =>
  (usuariosAll || []).some(
    (x: any) => String(x?.ID_USUARIO) === String(identificador ?? '').trim()
  );

const buildAltaNuevoPayload = (
  form: AltaFormForm,
  usuarioAltaBaja: any
) => ({
  idUsuario: String(form.identificador ?? '').trim(),
  nombreUsuario: String(form.nombre ?? '').trim(),
  idPerfil: '311',
  usuarioAlta: String(usuarioAltaBaja ?? ''),
  sociedadUsuario: String(form.sociedadId ?? '').trim(),
  tipoUsuario: 'INTERNO',
});

const hasPayloadAltaNuevoRequiredData = (payload: any): boolean =>
  Boolean(payload.idUsuario && payload.nombreUsuario && payload.sociedadUsuario);
const getUniqueSelectedIdsFromUI = (selectedUserUI: string): string[] => {
  const detail = JSON.parse(selectedUserUI || '[]');
  const csv = arrayToAPI(detail);
  const ids = (csv || '').split(',').map((x) => x.trim()).filter(Boolean);

  return Array.from(new Set(ids));
};

type AltaSelectorResult = {
  idsToEnable: string[];
  idsToInsert: string[];
  idsAlreadyActive: string[];
  idsNotFound: string[];
};

const getRowsByUsuarioId = (usuariosAll: any, idUsuario: string): any[] =>
  (usuariosAll || []).filter(
    (x: any) => String(x?.ID_USUARIO) === String(idUsuario)
  );

const getAltaSelectorCategory = (
  rows: any[]
): 'notFound' | 'alreadyActive' | 'enable' | 'insert' => {
  if (!rows.length) {
    return 'notFound';
  }

  const has311ActivoS = rows.some(
    (x: any) => String(x?.ID_PERFIL) === '311' && String(x?.ACTIVO) === 'S'
  );
  const has311ActivoN = rows.some(
    (x: any) => String(x?.ID_PERFIL) === '311' && String(x?.ACTIVO) === 'N'
  );
  const hasAny311 = rows.some((x: any) => String(x?.ID_PERFIL) === '311');

  if (has311ActivoS) {
    return 'alreadyActive';
  }

  if (has311ActivoN) {
    return 'enable';
  }

  return hasAny311 ? 'alreadyActive' : 'insert';
};

const addAltaSelectorId = (
  result: AltaSelectorResult,
  category: 'notFound' | 'alreadyActive' | 'enable' | 'insert',
  idUsuario: string
): void => {
  const target = {
    notFound: result.idsNotFound,
    alreadyActive: result.idsAlreadyActive,
    enable: result.idsToEnable,
    insert: result.idsToInsert,
  }[category];

  target.push(idUsuario);
};

const classifyAltaSelectorIds = (
  ids: string[],
  usuariosAll: any
): AltaSelectorResult => {
  const result: AltaSelectorResult = {
    idsToEnable: [],
    idsToInsert: [],
    idsAlreadyActive: [],
    idsNotFound: [],
  };

  ids.forEach((idUsuario) => {
    const rows = getRowsByUsuarioId(usuariosAll, idUsuario);
    const category = getAltaSelectorCategory(rows);
    addAltaSelectorId(result, category, idUsuario);
  });

  return result;
};

const buildInsertarUsuarioPerfilPayload = (
  idUsuario: string,
  usuariosAll: any,
  usuarioAltaBaja: any
) => {
  const rows = getRowsByUsuarioId(usuariosAll, idUsuario);
  const u = rows[0];

  return {
    idUsuario: String(u.ID_USUARIO),
    nombreUsuario: String(u.NOMBRE_USUARIO ?? ''),
    idPerfil: '311',
    usuarioAlta: String(usuarioAltaBaja ?? ''),
    sociedadUsuario: String(u.SOCIEDAD_USUARIO ?? ''),
    tipoUsuario: String(u.TIPO_USUARIO ?? ''),
  };
};

const getAltaSelectorResultParts = (result: AltaSelectorResult): string[] => {
  const parts: string[] = [];

  if (result.idsToEnable.length) parts.push(`Habilitar: ${result.idsToEnable.length}`);
  if (result.idsToInsert.length) parts.push(`Insertar: ${result.idsToInsert.length}`);
  if (result.idsAlreadyActive.length) parts.push(`Ya activos: ${result.idsAlreadyActive.length}`);

  return parts;
};
/* ========================================================================== */

const selectors = createStructuredSelector({
  usuariosAll: makeSelectAllUsuarios(),
  usuarioAltaBaja: makeSelectUsername(),
  sociedades: makeSelectSociedadesParse(),
  cursos: makeSelectCursosPracticaParse2(),
  formadoresData: makeSelectAllFormadores(),
  cursosCompletos: makeSelectCursos(),
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
} as any);

export default function AltaFormadores(): ReactElement {
  const dispatch = useDispatch();
  const { usuariosAll, usuarioAltaBaja, sociedades, cursos, formadoresData, cursosCompletos, profileActive} = useSelector<any, any>(selectors);

  // Campos de Alta Nuevo
  const [form, setForm] = useState<AltaFormForm>({ nombre: '', identificador: '', sociedadId: '' });
  const [errors, setErrors] = useState<{
    nombre?: string;
    identificador?: string;
    sociedadId?: string;
    altaSel?: string;
    bajaSel?: string;
    cursosSel?: string;
    fechaFin?: string;
  }>({});
  const [saving, setSaving] = useState(false);

  // Modal
  const [modalType, setModalType] = useState<'success' | 'alert' | 'confirm' | ''>('');
  const [modalMsg, setModalMsg] = useState<string>('');

  const abrir = (msg: string, tipo: 'success' | 'alert' | 'confirm' = 'success') => {
    setModalMsg(msg);
    setModalType(tipo);
  };


  // Selectores ALTA / BAJA
  const usersOptionsAlta = useMemo(() => JSON.stringify(normalizeUsuariosToOptions(usuariosAll)), [usuariosAll]);
  const usersOptionsBaja = useMemo(() => JSON.stringify(normalizeUsuariosToOptions2(usuariosAll)), [usuariosAll]);
  const [selectedUserAltaUI, setSelectedUserAltaUI] = useState<string>('[]');
  const [selectedUserBajaUI, setSelectedUserBajaUI] = useState<string>('[]');
  const [selectedCursosUI, setSelectedCursosUI] = useState<string>('[]');
  const [selectedCursosNoFormadorUI, setSelectedCursosNoFormadorUI] = useState<string>('[]');
  const [cursosResetKey, setCursosResetKey] = useState(0);
  const [usuariosBajaResetKey, setUsuariosBajaResetKey] = useState(0);
  const [usuariosAltaResetKey, setUsuariosAltaResetKey] = useState(0);
  const [sociedadResetKey, setSociedadResetKey] = useState(0);


  //Fecha fin obligatoria: timestamp ms como string
  const [selectedFechaFinUI, setSelectedFechaFinUI] = useState<string>(() => String(Date.now()));
  const [fechaResetKey, setFechaResetKey] = useState(0);

  // Selector SOCIEDADES (single)
  const sociedadesOptions = useMemo(() => JSON.stringify(normalizeSociedadesToOptions(sociedades)), [sociedades]);
  const [selectedSociedadUI, setSelectedSociedadUI] = useState<string>('[]');


  // Cargar usuarios y sociedades al montar
  useEffect(() => {
    dispatch(getAllUsuarios());
    dispatch(getAllFormadores());
    dispatch(getSociedadesRequest() as any);
  dispatch(getCursos(filtroCurso));
  }, [dispatch]);


  // Mantener margen sincronizado con el panel lateral
  useEffect(() => {
    const btn = document.querySelector('div.ui-lateral-menu > button.ui-lateral-menu__menu-button');
    const syncBodyClass = () => {
      if (!btn) return;
      const open = btn.classList.contains('ui-lateral-menu__menu-button--open');
      document.body.classList.toggle('left-menu-open', open);
    };
    let observer: MutationObserver | null = null;
    document.body.classList.add('left-menu-open');
    if (btn) {
      btn.addEventListener('click', syncBodyClass);
      observer = new MutationObserver(syncBodyClass);
      observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
    }
    syncBodyClass();
    return () => {
      if (btn) btn.removeEventListener('click', syncBodyClass);
      if (observer) observer.disconnect();
      document.body.classList.remove('left-menu-open');
    };
  }, []);



  const clearSelectors = () => {
    setSelectedUserAltaUI('[]');
    setSelectedUserBajaUI('[]');
    setUsuariosBajaResetKey((k) => k + 1);
    setUsuariosAltaResetKey((k) => k + 1);
    clearCursosSelector();
  };

  const clearCursosSelector = () => {
    setSelectedCursosUI('[]');
    setSelectedCursosNoFormadorUI('[]');
    setCursosResetKey((k) => k + 1);
  };

  const abrirModal = (mensaje: string, tipo: 'success' | 'alert' = 'success') => {
    setModalMsg(mensaje);
    setModalType(tipo);
  };
  const cerrarModal = () => {
    setModalType('');
    setModalMsg('');
  };

const [cursosFiltrados, setCursosFiltrados] = useState<string>('[]');
const [cursosNoFormador, setCursosNoFormador] = useState<string>('[]');


  // Filtrar cursos de los formadores seleccionados
  useEffect(() => {
    try {
      const list = typeof cursos === 'string' ? JSON.parse(cursos) : cursos;
      setCursosFiltrados(JSON.stringify(list));
    } catch {
      setCursosFiltrados('[]');
    }
}, [cursos]);

  // ======= Handlers Selectores =======
  const handleSelectedCurso = (e: any) => {
    const detail = e?.detail ?? [];

    setSelectedCursosUI(JSON.stringify(detail));
    actualizarFechaFinPorCurso(detail);

    setErrors((p) => ({ ...p, cursosSel: undefined }));
    if (!detail.length) {
      setCursosResetKey((k) => k + 1);
    }
  };

const filtrarCursosPorUsuario = (detail: any) => {
  try {
    const selectedUsers = Array.isArray(detail) ? detail : [];

    const selectedIds = selectedUsers
      .map((u: any) => String(u?.value ?? '').trim())
      .filter(Boolean);

    const cursosList =
      typeof cursos === 'string' ? JSON.parse(cursos) : cursos;

    const formadoresList =
      typeof formadoresData === 'string'
        ? JSON.parse(formadoresData)
        : formadoresData;

    const cursosBase = cursosList || [];

    if (!selectedIds.length) {
      setCursosFiltrados(JSON.stringify(cursosBase));
      setCursosNoFormador(JSON.stringify([]));
      clearCursosSelector();
      return;
    }

    const getIdCurso = (c: any) =>
      String(c?.ID_CURSO ?? c?.id ?? c?.value?.ID_CURSO ?? c?.value ?? '');

    const cursosPorFormador: Record<string, Set<string>> = {};

    selectedIds.forEach((idFormador) => {
      cursosPorFormador[idFormador] = new Set(
        (formadoresList || [])
          .filter((r: any) => String(r?.ID_FORMADOR) === String(idFormador))
          .map((r: any) => String(r?.ID_CURSO))
          .filter(Boolean)
      );
    });

    // Cursos donde TODOS los formadores seleccionados coinciden como formadores
    const cursosFormadorComun = cursosBase.filter((c: any) => {
      const idCurso = getIdCurso(c);

      return selectedIds.every((idFormador) =>
        cursosPorFormador[idFormador]?.has(idCurso)
      );
    });

    // Cursos donde NINGUNO de los formadores seleccionados es formador
    const cursosNoFormadorComun = cursosBase.filter((c: any) => {
      const idCurso = getIdCurso(c);

      return selectedIds.every(
        (idFormador) => !cursosPorFormador[idFormador]?.has(idCurso)
      );
    });

    setCursosFiltrados(JSON.stringify(cursosFormadorComun));
    setCursosNoFormador(JSON.stringify(cursosNoFormadorComun));

    clearCursosSelector();
  } catch {
    setCursosFiltrados('[]');
    setCursosNoFormador('[]');
    clearCursosSelector();
  }
};

  // ====== Selector Usuario ALTA ======
const handleSelectedUserAlta = (e: any) => {
    const detail = e?.detail ?? [];

    const merged = mergeSelectedOptions(selectedUserAltaUI, detail);

    setSelectedUserAltaUI(JSON.stringify(merged));

    setErrors((p) => ({
      ...p,
      altaSel: undefined,
      identificador: undefined,
    }));
    if (!merged.length) {
      setUsuariosAltaResetKey((k) => k + 1);
    }
};

  // ====== Selector Usuario BAJA ======
const handleSelectedUserBaja = (e: any) => {
  const detail = e?.detail ?? [];

  const merged = mergeSelectedOptions(selectedUserBajaUI, detail);

  setSelectedUserBajaUI(JSON.stringify(merged));
  filtrarCursosPorUsuario(merged);
  setErrors((p) => ({ ...p, bajaSel: undefined }));
  if (!merged.length) {
    setUsuariosBajaResetKey((k) => k + 1);
  }
};

  // ====== Selector Sociedad (SINGLE) ======
  const handleSelectedSociedad = (e: any) => {
    const detail = Array.isArray(e?.detail) ? e.detail : [];

    // Forzar SINGLE: quedarnos con la última selección
    const last = detail.length ? detail[detail.length - 1] : null;
    const singleArr = last ? [last] : [];

    setSelectedSociedadUI(JSON.stringify(singleArr));

    const v = singleArr[0]?.value;
    const idSoc =
      typeof v === 'string' ? v : String(v?.ID_SOCIEDAD ?? v?.value?.ID_SOCIEDAD ?? '');

    setForm((p) => ({ ...p, sociedadId: idSoc }));
    setErrors((p) => ({ ...p, sociedadId: undefined }));
  };


  const canSee = useCan();

  // ====== Acciones selector ======
  const onAltaFromSelector = () => {
    const ids = getUniqueSelectedIdsFromUI(selectedUserAltaUI);

    if (!ids.length) {
      setErrors((p) => ({ ...p, altaSel: 'Seleccione usuario' }));
      abrirModal('Debe seleccionar al menos un usuario.', 'alert');
      return;
    }

    const altaSelectorResult = classifyAltaSelectorIds(ids, usuariosAll);

    if (altaSelectorResult.idsNotFound.length) {
      abrirModal(`No se han encontrado en el listado estos usuarios: ${altaSelectorResult.idsNotFound.join(', ')}`, 'alert');
      return;
    }

    if (altaSelectorResult.idsToEnable.length) {
      dispatch(habilitarUsuarioPerfil({ idUsuarios: altaSelectorResult.idsToEnable.join(','), idPerfil: '311' } as any));
    }

    for (const idUsuario of altaSelectorResult.idsToInsert) {
      const payload = buildInsertarUsuarioPerfilPayload(
        idUsuario,
        usuariosAll,
        usuarioAltaBaja
      );

      if (!payload.nombreUsuario) {
        abrirModal(`Faltan datos obligatorios para el alta del usuario ${idUsuario} (nombreUsuario).`, 'alert');
        return;
      }

      dispatch(insertarUsuarioPerfil(payload as any));
    }

    const parts = getAltaSelectorResultParts(altaSelectorResult);

    clearSelectors();

    abrirModal(
      parts.length ? `Se han enviado las peticiones. (${parts.join(' · ')})` : 'No hay acciones a realizar.',
      'success'
    );
  };

   const onAltaCursoFromSelector = () => {
    const idFormadores = getValuesFromUIJson(selectedUserBajaUI);
    const idCursos = getValuesFromUIJson(selectedCursosNoFormadorUI);

    const errs: typeof errors = {};
    if (!idFormadores.length) errs.bajaSel = 'Seleccione al menos un formador';
    if (!idCursos.length) errs.cursosSel = 'Seleccione al menos un curso';
    if (!selectedFechaFinUI) errs.fechaFin = 'Seleccione una fecha';
    setErrors(errs);
    if (Object.keys(errs).length) return;

    const data = parseArrayMaybeJson(formadoresData);
    const cursosSet = new Set(idCursos.map((c) => String(c)));

    const duplicatesByFormador: Record<string, string[]> = {};
    for (const idFormador of idFormadores) {
      const rows = data.filter((r: any) => String(r?.ID_FORMADOR) === String(idFormador));
      const dupCursos = rows
        .map((r: any) => String(r?.ID_CURSO))
        .filter((idCurso: string) => cursosSet.has(idCurso));

      if (dupCursos.length) duplicatesByFormador[String(idFormador)] = Array.from(new Set(dupCursos));
    }

    const dupFormadores = Object.keys(duplicatesByFormador);
    if (dupFormadores.length) {
      const lines = dupFormadores.map((g) => `Formador ${g}: cursos ya asociados (${duplicatesByFormador[g].join(', ')})`);
      abrir(`No se ha enviado ninguna petición.\n\nYa existen asociaciones:\n- ${lines.join('\n- ')}`, 'alert');
      return;
    }

  const nombreByFormador = (idFormador: string): string => {
      const usuarios = parseArrayMaybeJson(usuariosAll);

      const row = usuarios.find(
        (u: any) =>
          String(u?.ID_USUARIO) === String(idFormador) &&
          String(u?.ID_PERFIL) === '311'
      );

      return String(row?.NOMBRE_USUARIO ?? '');
    };
    const fechaFin = selectedFechaFinUI;

    setSaving(true);
    try {
      for (const idFormador of idFormadores) {
        for (const idCurso of idCursos) {
          const payload = {
            idCursos: String(idCurso),
            idFormador: String(idFormador),
            nombreFormador: nombreByFormador(String(idFormador)),
            usuarioAlta: String(usuarioAltaBaja ?? ''),
            fechaIniFormCurso: getFechaInicioCurso(String(idCurso)),
            fechaFinFormCurso: isActiveFechaFinChecked ?  getFechaFinCurso(String(idCurso)) : fechaFin,
            usuarioModificacion: String(usuarioAltaBaja ?? ''),
            sociedadFormador: '10000000',
            sociedadCurso: '10000000',
          };

          dispatch(insertarFormadoresCursos(payload as any));
        }
      }

      abrir(
        `Se han enviado las peticiones. (Alta: ${idFormadores.length} formador(es) · Cursos: ${idCursos.length})`,
        'success'
      );
      limpiar();
    } finally {
      setSaving(false);
    }
  };



  // ======= Baja desde selectores =======
 const onBajaCursoFromSelector = () => {
  const idFormadoresArr = getValuesFromUIJson(selectedUserBajaUI);
  const idCursosArr = getValuesFromUIJson(selectedCursosUI);

  const errs: typeof errors = {};
  if (!idFormadoresArr.length) errs.bajaSel = 'Seleccione al menos un formador';
  if (!idCursosArr.length) errs.cursosSel = 'Seleccione al menos un curso';
  setErrors(errs);
  if (Object.keys(errs).length) return;

  const data = parseArrayMaybeJson(formadoresData);

  // comprobar asociaciones existentes y detectar faltantes
  const missingByFormador: Record<string, string[]> = {};

  for (const idFormador of idFormadoresArr) {
    const rowsFormador = data.filter((r: any) => String(r?.ID_FORMADOR) === String(idFormador));
    const cursosAsociados = new Set(rowsFormador.map((r: any) => String(r?.ID_CURSO)).filter(Boolean));

    const faltan = idCursosArr
      .map(String)
      .filter((idCurso) => !cursosAsociados.has(String(idCurso)));

    if (faltan.length) missingByFormador[String(idFormador)] = Array.from(new Set(faltan));
  }

  const formadoresConFaltantes = Object.keys(missingByFormador);

  // si falta alguna asociación, no hacemos ninguna baja
  if (formadoresConFaltantes.length) {
    const lines = formadoresConFaltantes.map(
      (g) => `Formador ${g}: NO está asociado a cursos (${missingByFormador[g].join(', ')})`
    );

    abrir(
      `No se ha enviado ninguna petición.\n\nFaltan asociaciones para los cursos seleccionados:\n- ${lines.join(
        '\n- '
      )}`,
      'alert'
    );
    return;
  }

  // si todo está asociado, hacemos la baja
  const payloadBaja = {
    idCursos: idCursosArr.join(','),
    idFormadores: idFormadoresArr.join(','),
  };

  // Calcular formadores que se quedarían sin cursos tras la baja
  const cursosBajaSet = new Set(idCursosArr.map(String));
  const formadoresSinCursosTrasBaja: string[] = [];

  for (const idFormador of idFormadoresArr) {
    const rowsFormador = data.filter((r: any) => String(r?.ID_FORMADOR) === String(idFormador));
    const cursosActuales = Array.from(
      new Set(rowsFormador.map((r: any) => String(r?.ID_CURSO)).filter(Boolean))
    );

    const cursosRestantes = cursosActuales.filter((c) => !cursosBajaSet.has(String(c)));

    if (cursosRestantes.length === 0) {
      formadoresSinCursosTrasBaja.push(String(idFormador));
    }
  }

  dispatch(eliminarFormadoresCursos(payloadBaja as any));

  if (formadoresSinCursosTrasBaja.length) {
    dispatch(
      eliminarUsuarioPerfil({
        idUsuarios: formadoresSinCursosTrasBaja.join(','),
        idPerfil: '311',
        idUsuarioModificacion: String(usuarioAltaBaja ?? ''),
      } as any)
    );
  }

  abrir('Se ha enviado la petición de BAJA de los formadores en los cursos seleccionados.', 'success');
  limpiar();
};


  const onBajaFromSelector = () => {
    const detail = JSON.parse(selectedUserBajaUI || '[]');
    const csv = arrayToAPI(detail);
    const ids = (csv || '').split(',').map((x) => x.trim()).filter(Boolean);

    if (!ids.length) {
      setErrors((p) => ({ ...p, bajaSel: 'Seleccione usuario' }));
      abrirModal('Debe seleccionar al menos un usuario.', 'alert');
      return;
    }

    const uniqueIds = Array.from(new Set(ids));

    const idsNotFound: string[] = [];
    const idsToDelete: string[] = [];

    for (const idUsuario of uniqueIds) {
      const exists = (usuariosAll || []).some((x: any) => String(x?.ID_USUARIO) === String(idUsuario));
      if (!exists) idsNotFound.push(idUsuario);
      else idsToDelete.push(idUsuario);
    }

    if (idsNotFound.length) {
      abrirModal(`No se han encontrado en el listado estos usuarios: ${idsNotFound.join(', ')}`, 'alert');
      return;
    }

    if (idsToDelete.length) {
      dispatch(eliminarUsuarioPerfil({ idUsuarios: idsToDelete.join(','), idPerfil: '311' } as any));
    }

    const parts: string[] = [];
    if (idsToDelete.length) parts.push(`Baja: ${idsToDelete.length}`);

    clearSelectors();

    abrirModal(
      parts.length ? `Se han enviado las peticiones. (${parts.join(' · ')})` : 'No hay acciones a realizar.',
      'success'
    );
  };

  // ====== Alta Nuevo por campos ======
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
    setErrors((p) => ({ ...p, [name]: undefined }));
  };

  const limpiar = () => {
    setForm({ nombre: '', identificador: '', sociedadId: '' });
    setErrors({});
    clearSelectors();
    clearFechaFin();
    setSelectedSociedadUI('[]');
    resetCursosOptions();
    setSociedadResetKey((k) => k + 1);
  };

  const validarAltaNuevo = (): boolean => {
    const n: typeof errors = {};
    if (!form.nombre.trim()) n.nombre = 'El nombre es obligatorio';
    if (!form.identificador.trim()) n.identificador = 'El identificador es obligatorio';
    if (!form.sociedadId.trim()) n.sociedadId = 'La sociedad es obligatoria';
    setErrors(n);
    return Object.keys(n).length === 0;
  };

  // Alta Nuevo
  const onSubmitAltaNuevo = async () => {
    if (!validarAltaNuevo()) return;

    setSaving(true);
    try {

      if (usuarioExiste(usuariosAll, form.identificador)) {
        abrirModal('Este usuario ya existe.', 'alert');
        return;
      }

      const payload = buildAltaNuevoPayload(form, usuarioAltaBaja);

      if (!hasPayloadAltaNuevoRequiredData(payload)) {
        abrirModal('Faltan datos obligatorios para el alta.', 'alert');
        return;
      }

      dispatch(insertarUsuarioPerfil(payload as any));

      abrirModal('Se ha enviado la petición de ALTA del usuario.', 'success');
      limpiar();
    } catch {
      abrirModal('Ha ocurrido un error al dar de alta.', 'alert');
    } finally {
      setSaving(false);
    }
  };

  //Deshabilitar selector de cursos si no hay ningún formador seleccionado en baja (que es el que marca los cursos asociados)
  const formadoresSeleccionados = JSON.parse(selectedUserBajaUI || '[]').length > 0;
  const cursosDisabled = !formadoresSeleccionados;
  const cursosBajaSeleccionados= JSON.parse(selectedCursosUI || '[]').length > 0;
  const cursosBajaDisabled = !cursosBajaSeleccionados
  const cursosAltaSeleccionados= JSON.parse(selectedCursosNoFormadorUI || '[]').length > 0;
  const cursosAltaDisabled = !cursosAltaSeleccionados
  const [isActiveFechaFinChecked, setIsActiveFechaFinChecked] = useState(true);

  const TODAY_TS = useMemo(() => String(Date.now()), []);
  const MAX_TS = useMemo(() => String(new Date(2099, 11, 31).getTime()), []);

  const clearFechaFin = () => {
    setSelectedFechaFinUI(TODAY_TS);
    setFechaResetKey((k) => k + 1);
  };

    const handleFechaFinSelected = (e: any) => {
    const tsMs = extractTimestampMsString(e);
    setSelectedFechaFinUI(tsMs);
    setErrors((p) => ({ ...p, fechaFin: undefined }));
  };

const actualizarFechaFinPorCurso = (detail: any[]) => {
  const selected = Array.isArray(detail) ? detail : [];

  if (!selected.length) {
    clearFechaFin();
    return;
  }

  const lastCurso = selected[selected.length - 1];
  const idCurso = String(lastCurso?.value ?? lastCurso?.ID_CURSO ?? '');

  const cursosFull = parseArrayMaybeJson(cursosCompletos);

  const cursoCompleto = cursosFull.find(
    (c: any) => String(c?.ID_CURSO) === idCurso
  );

  const fechaFinCurso = cursoCompleto?.FECHA_FIN_CURSO;

  if (fechaFinCurso) {
    setSelectedFechaFinUI(String(fechaFinCurso));
    setFechaResetKey((k) => k + 1);
    setErrors((p) => ({ ...p, fechaFin: undefined }));
  }
};

const resetCursosOptions = () => {
  const cursosList = parseArrayMaybeJson(cursos);
  setCursosFiltrados(JSON.stringify(cursosList));
  setCursosNoFormador('[]');
};

const getFechaInicioCurso = (idCurso: string): string => {
  const cursosFull = parseArrayMaybeJson(cursosCompletos);

  const cursoCompleto = cursosFull.find(
    (c: any) => String(c?.ID_CURSO) === String(idCurso)
  );

  return String(cursoCompleto?.FECHA_INI_CURSO ?? Date.now());
};

 const handleCheckboxChange = (event) => {
    setIsActiveFechaFinChecked(!isActiveFechaFinChecked);
  };

  useEffect(() => {
    limpiar();
  }, [profileActive]);

  const getFechaFinCurso = (idCurso: string): string => {
  const cursosFull = parseArrayMaybeJson(cursosCompletos);

  const cursoCompleto = cursosFull.find(
    (c: any) => String(c?.ID_CURSO) === String(idCurso)
  );

  return String(cursoCompleto?.FECHA_FIN_CURSO ?? Date.now());
};

const mergeSelectedOptions = (previousJson: string, currentDetail: any[]) => {
  const previous = parseArrayMaybeJson(previousJson);
  const current = Array.isArray(currentDetail) ? currentDetail : [];

  const previousMap = new Map<string, any>();
  previous.forEach((item: any) => {
    const value = String(item?.value ?? '');
    if (value) previousMap.set(value, item);
  });

  const currentMap = new Map<string, any>();
  current.forEach((item: any) => {
    const value = String(item?.value ?? '');
    if (value) currentMap.set(value, item);
  });

  const previousValues = Array.from(previousMap.keys());
  const currentValues = Array.from(currentMap.keys());

  const addedValues = currentValues.filter((v) => !previousMap.has(v));
  const removedValues = previousValues.filter((v) => !currentMap.has(v));

  // Selección nueva tras búsqueda: mantener anteriores + añadir nuevos
  if (addedValues.length) {
    addedValues.forEach((v) => {
      previousMap.set(v, currentMap.get(v));
    });

    return Array.from(previousMap.values());
  }

  // Deselección: quitar los que ya no vienen en detail
  if (removedValues.length) {
    removedValues.forEach((v) => {
      previousMap.delete(v);
    });

    return Array.from(previousMap.values());
  }

  return current;
};

  return (
    <>
      <Header />
      <div className="alta-formadores">
        <RfUiBreadcrumbs
          links={JSON.stringify([{ label: 'Alta Formadores', link: '/altaFormadores', textHelp: 'Alta Formadores', active: true }])}
          onEventChange={(e: any) => { window.history.pushState({}, '', e.detail); }}
        />
        <h1 className="page-title">Alta Formadores</h1>

        <div className="rf-flex rf-gap-24 rf-flex-wrap selectors-row">
          <div className="selector-col form-group rf-flex-1">
            <RfUiMultiselect
              key={`alta-${usersOptionsAlta}-${usuariosAltaResetKey}`}
              options={usersOptionsAlta}
              defaultChecksRemake={selectedUserAltaUI}
              withoutOptionsText="Sin opciones"
              textError="Seleccione al menos una opción"
              text-label="Usuario"
              placeholder="Seleccione usuario(s)"
              onOptionSelected={handleSelectedUserAlta}
            />
            {errors.altaSel && <div className="error">{errors.altaSel}</div>}
            {canSee.canSeePerfil ? (
              <div className="rf-flex rf-justify-center selectors-cta">
                <RfUiButton disabled={saving} text="Alta" text-help="Alta" onButtonClick={onAltaFromSelector} />
              </div>
            ) : null}
          </div>

          <div className="selector-col form-group rf-flex-1">
            <RfUiMultiselect
              key={`baja-${usersOptionsBaja}-${usuariosBajaResetKey}`}
              options={usersOptionsBaja}
              defaultChecksRemake={selectedUserBajaUI}
              withoutOptionsText="Sin opciones"
              textError="Seleccione al menos una opción"
              text-label="Form."
              placeholder="Seleccione formador(es)"
              onOptionSelected={handleSelectedUserBaja}
            />
            {errors.bajaSel && <div className="error">{errors.bajaSel}</div>}
            {canSee.canSeePerfil ? (
              <div className="rf-flex rf-justify-center selectors-cta">
                <RfUiButton aspect="secondary" disabled={saving} text="Baja" text-help="Baja" onButtonClick={onBajaFromSelector} />
              </div>
            ) : null}

          </div>



          <div className="selector-col form-group rf-flex-1">
            <RfUiMultiselect
              key={`cursos-${cursosResetKey}`}
              options={cursosFiltrados}
              defaultChecksRemake={selectedCursosUI}
              withoutOptionsText="Sin opciones"
              textError="Seleccione al menos una opción"
              text-label="Cursos Form."
              placeholder="Seleccione curso(s)"
              onOptionSelected={handleSelectedCurso}
              disabled={cursosDisabled}
            />
            {errors.cursosSel && <div className="error">{errors.cursosSel}</div>}

            {canSee.canSeePerfil ? (
              <div className="rf-flex rf-justify-center selectors-cta">
                <RfUiButton
                  aspect="secondary"
                  disabled={saving || cursosBajaDisabled}
                  text="Curso Baja"
                  text-help="Curso Baja"
                  onButtonClick={onBajaCursoFromSelector}
                />
              </div>
            ) : null}
        </div>
        <div className="selector-col form-group rf-flex-1">
            <RfUiMultiselect
              key={`cursos-no-formador-${cursosResetKey}`}
              options={cursosNoFormador}
              defaultChecksRemake={selectedCursosNoFormadorUI}
              withoutOptionsText="Sin opciones"
              textError="Seleccione al menos una opción"
              text-label="Cursos NO formador"
              placeholder="Seleccione formador(s)"
              disabled={cursosDisabled}
              onOptionSelected={(e: any) => {
                const detail = e?.detail ?? [];

                setSelectedCursosNoFormadorUI(JSON.stringify(detail));
                actualizarFechaFinPorCurso(detail);

                setErrors((p) => ({ ...p, cursosSel: undefined }));
                if (!detail.length) {
                  setCursosResetKey((k) => k + 1);
                }
            }}
            />

            {canSee.canSeePerfil ? (
              <div className="rf-flex rf-justify-center selectors-cta">
                <RfUiButton
                  aspect="secondary"
                  disabled={saving || cursosAltaDisabled}
                  text="Curso Alta"
                  text-help="Curso Alta"
                  onButtonClick={onAltaCursoFromSelector}
                />
              </div>
            ) : null}
          </div>
        </div>

        <div className="form-group rf-flex-1 fecha-fin-formador">
          <RfUiDatepicker
              key={`fecha-fin-${fechaResetKey}`}
              position="left"
              moment-locale="es"
              labelInput="Fecha Fin"
              text-apply-button="Aplicar"
              defaultMinDateFrom={TODAY_TS}
              defaultMaxDateFrom={MAX_TS}
              defaultDateFrom={selectedFechaFinUI}
              onDateSelected={handleFechaFinSelected}
              disabled={isActiveFechaFinChecked}
            />
            {errors.fechaFin && <div className="error">{errors.fechaFin}</div>}

            <div className="form-group rf-flex-1 fecha-fin-formador-checkbox">
                <RfUiCheckbox
                  label="Cursos Activos"
                  checked={isActiveFechaFinChecked}
                  onCheckEvent={handleCheckboxChange}
                /><small>Crear con fecha fin de curso</small>
            </div>
          </div>

        <form className="form" onSubmit={(e) => { e.preventDefault(); onSubmitAltaNuevo(); }}>
          <div className="form-group">
            <label htmlFor="nombre" className="sr-only">Nombre usuario</label>
            <div className="input-prefixed">
              <span className="prefix">Nombre</span>
              <input id="nombre" name="nombre" value={form.nombre} onChange={onChange} placeholder="Introduzca nombre" />
            </div>
            {errors.nombre && <div className="error">{errors.nombre}</div>}
          </div>

          <div className="form-group">
            <label htmlFor="identificador" className="sr-only">Identificador usuario</label>
            <div className="input-prefixed">
              <span className="prefix">Identificador</span>
              <input id="identificador" name="identificador" value={form.identificador} onChange={onChange} placeholder="Introduzca identificador" />
            </div>
            {errors.identificador && <div className="error">{errors.identificador}</div>}
          </div>

          {/* Selector Sociedad (SINGLE) */}
          <div className="form-group sociedad-single">
            <RfUiMultiselect
              key={`sociedades-${sociedadesOptions}-${sociedadResetKey}`}
              options={sociedadesOptions}
              defaultChecksRemake={selectedSociedadUI}
              withoutOptionsText="Sin opciones"
              textError="Seleccione una opción"
              text-label="Sociedad"
              placeholder="Seleccione sociedad"
              onOptionSelected={handleSelectedSociedad}
            />
            {errors.sociedadId && <div className="error">{errors.sociedadId}</div>}
          </div>

          <div className="actions">
            <RfUiButton
              aspect="secondary"
              text="Limpiar filtro"
              text-help="Limpiar filtro"
              onButtonClick={() => limpiar()}
            />
            <div className="actions-right">
              {canSee.canSeePerfil ? (
              <RfUiButton
                disabled={saving}
                text={saving ? 'Guardando…' : 'Alta Nuevo'}
                text-help="Alta Nuevo"
                onButtonClick={() => onSubmitAltaNuevo()}
              />
              ) : null}
            </div>
          </div>
        </form>
      </div>

      {/* Modal */}
      <RfUiModal
        title-modal={modalMsg}
        id-modal="modalAltaFormador"
        modal-type={modalType}
        modalConfirmText="Aceptar"
        onModalClose={() => cerrarModal()}
        onConfirm={() => cerrarModal()}
      />
    </>
  );
}
